var SsoLogin = (function () {
	const login = () => {
		var ssoEmail = $.trim($("#ssoEmailInput").val());
	}
	return {login: login}
})()
